import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';

import { SgBaseSharedRoutingModule } from './sg-base-shared-routing.module';
import { DateYmStringSgPipe } from './pipes/date-ym-string-sg.pipe';
import { SgAriaMessageComponent } from './components/sg-aria-message/sg-aria-message.component';
import { SharedModule } from 'cbc-shared-lib';
import { SgJpDateAdapter } from './sg-jp-date-adapter';
import { DateAdapter } from '@angular/material/core';
import { Sgkz003dComponent } from './pages/sgkz003d/components/sgkz003d.component';
import { Sgkz004dComponent } from './pages/sgkz004d/components/sgkz004d.component';
import { MatPaginatorIntlJa } from './mat-paginator-intl-ja';
import { MatPaginatorIntl } from '@angular/material/paginator';


@NgModule({
  declarations: [
    DateYmStringSgPipe,
    SgAriaMessageComponent,
    Sgkz003dComponent,
    Sgkz004dComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    SgBaseSharedRoutingModule,
  ],
  providers: [
    // 西部ガスオリジナル日付カレンダー使用に必要 
    { provide: DateAdapter, useClass: SgJpDateAdapter },
    // リスト選択ページ制御の日本語化に必要
    { provide: MatPaginatorIntl, useClass: MatPaginatorIntlJa },
  ],
  exports: [
    DateYmStringSgPipe,
    SgAriaMessageComponent,
  ]
})
export class SgBaseSharedModule { }
